import { REFRESH_TOKEN, ACCESS_TOKEN, EMAIL } from '../constants';
import Cookies from 'js-cookie';

export function removeTokenCookies(): void {
  Cookies.remove(ACCESS_TOKEN);
  Cookies.remove(REFRESH_TOKEN);
}

export function removeCredentialsCookies(): void {
  Cookies.remove(EMAIL);
}

export function addTokenCookies({
  accessToken,
  refreshToken,
}: {
  accessToken: string;
  refreshToken: string;
}): void {
  Cookies.set(ACCESS_TOKEN, accessToken);
  Cookies.set(REFRESH_TOKEN, refreshToken);
}

export function addCredentialsCookies({
  email,
}: {
  email: string;
}): void {
  Cookies.set(EMAIL, email);
}

export function getTokenCookies(): {
  accessToken?: string;
  refreshToken?: string;
} {
  const accessToken = Cookies.get(ACCESS_TOKEN);
  const refreshToken = Cookies.get(REFRESH_TOKEN);

  return {
    accessToken,
    refreshToken,
  };
}

export function getCredentialsCookies(): {
  email?: string;
} {
  const email = Cookies.get(EMAIL);

  return {
    email,
  };
}
